import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c69f8cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "f-c-w f-s20 f-w-b" }, "泉融和管理系统", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-content ep-bg-purple" }, null, -1))
const _hoisted_3 = { class: "el-dropdown-link" }

import router from "@/router";

// 退出登录

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const logout = () => {
  localStorage.removeItem('menuRole')
  localStorage.removeItem('routes')
  localStorage.removeItem("adminInfo");
  router.push("/login");
};
let userName = localStorage.getItem("adminInfo")
  ? JSON.parse(localStorage.getItem("adminInfo")!).adminName
  : "";

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_UserFilled = _resolveComponent("UserFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_User = _resolveComponent("User")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_SwitchButton = _resolveComponent("SwitchButton")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_component_el_row, {
    class: "row-bg",
    justify: "space-between"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_col, {
        span: 6,
        style: {"height":"60px"}
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, {
        span: 6,
        class: "col-end",
        style: {"height":"60px"}
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createVNode(_component_el_dropdown, null, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_dropdown_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_User)
                        ]),
                        _: 1
                      }),
                      _createTextVNode("个人中心")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_dropdown_item, { onClick: logout }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_SwitchButton)
                        ]),
                        _: 1
                      }),
                      _createTextVNode("退出登录")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_3, [
                _createVNode(_component_el_icon, {
                  size: 20,
                  color: "#fff",
                  class: "m-r5"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_UserFilled)
                  ]),
                  _: 1
                }),
                _createTextVNode(_toDisplayString(_unref(userName)) + " ", 1),
                _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_arrow_down)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})